import React, { useState } from "react";
import styles from "./index.module.css";
import { motion, AnimatePresence } from "framer-motion";
import Tabs from "../Tabs";
import { Calendar, Globe, ChevronDown, Clock } from "lucide-react";

const EventSchedule = () => {
    const [activeTab, setActiveTab] = useState("5th December");
    const data = {
        "5th December": [
            // { time: "9:00 AM - 9:30 AM", event: "Opening Remarks and Felicitation of the UoW Team by the Director" },
            { time: "9:30 AM onwards", event: "Dissemination Meeting" },
            //{ time: "12:00 PM - 2:00 PM", event: "Lunch" },
            //{ time: "2:00 PM - 3:30 PM", event: "Dissemination Meeting" },
            //{ time: "3:30 PM - 4:00 PM", event: "Tea Break" },
            //{ time: "8:00 PM onwards", event: "Dinner" },
        ],
        "6th December": [
            { time: "9:00 AM - 9:15 AM", event: "Opening Remarks by Prof. Manindra Agrawal, Director, IIT Kanpur" },
            { time: "9:15 AM - 9:45 AM", event: "Nishanth Chandran, Microsoft India" },
            { time: "9:45 AM - 10:15 AM", event: "Sikhar Patranabis, IBM Research India" },
            { time: "10:15 AM - 10:45 AM", event: "Kush Vyas, Amazon India" },
            { time: "10:45 AM - 11:00 AM", event: "Break" },
            { time: "11:00 AM - 11:30 AM", event: "Siddharth Sharma, Digi Yatra" },
            { time: "11:30 AM - 12:00 PM", event: "Devashish Gosain, IIT Bombay" },
            { time: "12:00 PM - 12:30 PM", event: "Teja Chintalapati, DSCI, India" },
            { time: "12:30 PM - 1:00 PM", event: "Priyanka Bagade, IIT Kanpur" },
            { time: "1:00 PM - 1:30 PM", event: "Rajesh Ranjan, IIT Kanpur" },
            { time: "1:30 PM - 2:30 PM", event: "Break" },
            { time: "2:30 PM - 3:00 PM", event: "Subhasis Mukhopadhyay" },
            { time: "3:00 PM - 4:00 PM", event: "Brainstorming Session" },
            // { time: "8:00 PM onwards", event: "Dinner" },
        ],
    };

    const tabsItems = [
        { label: "5th December", value: "5th December" },
        { label: "6th December", value: "6th December" },
    ];

    const ScheduleItem = ({ item, index }) => (
        <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="flex items-center space-x-4 p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
        >
            <div className="flex-shrink-0">
                <Clock className="w-6 h-6 text-indigo-500" />
            </div>
            <div className="flex-grow">
                <p className="font-semibold text-indigo-800">{item.time}</p>
                <p className="text-gray-600">{item.event}</p>
            </div>
        </motion.div>
    );

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
            <h2 className="heading">Event Schedule</h2>
            <div className="flex justify-center mb-9">
                <Tabs data={{ activeTab, setActiveTab, tabsItems }} />
            </div>
            <AnimatePresence mode="wait">
                <motion.div
                    key={activeTab}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.5 }}
                    className="grid gap-4 sm:grid-cols-1 md:grid-cols-2"
                >
                    {data[activeTab].map((item, index) => (
                        <ScheduleItem key={index} item={item} index={index} />
                    ))}
                </motion.div>
            </AnimatePresence>
        </div>
    );
};

export default EventSchedule;
